import { IEdetector } from '@utils/browserUTLs';
import { getDevice } from '@utils/getDevice';
import { action, configure, makeObservable, observable } from 'mobx';

configure({
  enforceActions: 'observed',
  useProxies: IEdetector() ? 'never' : 'always'
});

const Links = {
  ios: 'https://itunes.apple.com/ru/app/delikateska.ru-internet-magazin/id500480133?&mt=8',
  android: 'https://play.google.com/store/apps/details?id=com.rndelikateska'
};

const StoreKey = 'hideDownloadApp';

class Store {
  show = false;

  link = false;

  count = 1;

  constructor() {
    this.wakeUp();

    makeObservable(this, {
      show: observable,
      link: observable,
      count: observable,

      onPage: action,
      onResolve: action,
      wakeUp: action
    });
  }

  onPage() {
    this.count = this.count + 1;
  }

  onResolve = () => {
    this.show = false;
    localStorage.setItem(StoreKey, 'hide');
  };

  getDevice() {
    return getDevice();
  }

  getShow() {
    if (
      location.href.indexOf('prerender') !== -1 ||
      localStorage.getItem(StoreKey) != null
    ) {
      return false;
    }

    return true;
  }

  wakeUp() {
    const device = this.getDevice();

    if (device === false || typeof Links[device] === 'undefined') {
      return;
    }

    this.link = Links[device];
    this.show = this.getShow();
  }
}

const appStore = new Store();
export default appStore;
